import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IBulkOnboardingCommitResult, IBulkOnboardingReport } from '../interfaces/bulk-onboarding.interface';

/**
 * Bulk worker onboarding (CSV import) — decision note docs/decisions/2026-09-08-bulk-onboarding.md,
 * D2's validate-then-commit contract. The endpoint is the SAME multipart POST for both calls;
 * only the `dryRun` query param differs. `mapping` (2026-10-25 Excel slice) carries the user's
 * confirmed column choices, {"file header": "column key"}; omitted when empty.
 */
function buildForm(file: File, mapping: Record<string, string>): FormData {
    const formData = new FormData();
    formData.append('file', file);
    if (Object.keys(mapping).length > 0) {
        formData.append('mapping', JSON.stringify(mapping));
    }
    return formData;
}

export const UserBulkImportService = {
    dryRun: async (institutionId: string, file: File, mapping: Record<string, string> = {}): Promise<IBulkOnboardingReport> => {
        const response = await axios.post(ENDPOINTS.USER.BULK_ONBOARD(institutionId), buildForm(file, mapping), {
            params: { dryRun: true },
            headers: {
                ...AuthService.getAuthHeader(),
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    commit: async (institutionId: string, file: File, mapping: Record<string, string> = {}): Promise<IBulkOnboardingCommitResult> => {
        const response = await axios.post(ENDPOINTS.USER.BULK_ONBOARD(institutionId), buildForm(file, mapping), {
            params: { dryRun: false },
            headers: {
                ...AuthService.getAuthHeader(),
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },
};
